import React, { useEffect, useState } from 'react';

import { List } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';

import PermissionsError from '../Errors/Permission.js';

import 'antd/dist/reset.css';

import { convertToLocalTimezone } from '../../Helpers/Utils.js';
import { getNotificationsListUrl } from '../../Helpers/User.js';

import ListPagination from '../Utils/ListPagination.js';

function NotificationList(props) {
  let { userId } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const [error, setError] = useState('');
  const [notifications, setNotifications] = useState([]);
  const [totalNotifications, setTotalNotifications] = useState();
  const [itemsPerPage, setItemsPerPage] = useState(
    urlParams.get('items_per_page') ? urlParams.get('items_per_page') : 15
  );
  const [pageIndex, setPageIndex] = useState(
    urlParams.get('page_index') ? urlParams.get('page_index') : 1
  );
  const { updateNewNotificationsCount } = props;

  userId = userId === undefined ? '' : userId;

  useEffect(() => {
    let url = getNotificationsListUrl(userId, pageIndex, itemsPerPage);
    fetch(url).then(response => response.json()).then(data => {
      if (data.success === 1) {
        updateNewNotificationsCount(null);
        setNotifications(data.user_notifications);
        setTotalNotifications(data.notifications_count);
        navigate(
          `/user/${userId}/notifications` +
            `?page_index=${pageIndex}&items_per_page=${itemsPerPage}`
        );
      } else {
        setError(data.error);
      }
    });
  }, [userId, itemsPerPage, pageIndex, navigate, updateNewNotificationsCount]);

  if (error) return <PermissionsError />;

  return (
    <div className="cs-notifications">
      <div className="cs-notifications__head">
        <h1>{t('Notifications')}</h1>
        {totalNotifications != null && (
          <span className="count">
            {totalNotifications}{' '}
            {t(totalNotifications === 1 ? 'notification' : 'notifications')}
          </span>
        )}
      </div>

      <div className="cs-notifications__list">
        <List
          itemLayout="horizontal"
          dataSource={notifications}
          locale={{
            emptyText: (
              <div
                style={{
                  padding: 32,
                  color: 'var(--fg-3)',
                  fontFamily: 'var(--mono)',
                  fontSize: 13,
                }}
              >
                {t('no notifications yet')}
              </div>
            ),
          }}
          renderItem={item => (
            <List.Item style={{ padding: 0, border: 'none' }}>
              <div className={`cs-notif-row${item.seen ? ' is-seen' : ''}`}>
                <span
                  className={
                    `cs-notif-row__dot` +
                    (item.seen ? '' : ' is-new')
                  }
                />
                <div className="cs-notif-row__body">
                  <div className="cs-notif-row__text">
                    <Link to={item.link || '#'}>{t(item.body)}</Link>
                  </div>
                  <div className="cs-notif-row__time">
                    {convertToLocalTimezone(item.date_sent)}
                  </div>
                </div>
              </div>
            </List.Item>
          )}
        />
      </div>

      <div className="cs-notifications__pagination">
        <ListPagination
          itemsNumber={itemsPerPage}
          onItemsNumberChange={setItemsPerPage}
          onPageIndexChange={setPageIndex}
          pageIndex={pageIndex}
          totalItems={totalNotifications}
        />
      </div>
    </div>
  );
}

export default NotificationList;
